import { createServerFn } from '@tanstack/react-start';
import _ from 'lodash';

import { global_layout } from '#/content';

/**
 * Get the global configuration.
 */
export const getGlobalConfig = createServerFn({
  method: 'GET',
}).handler(async () => {
  return {
    layout: global_layout,
  };
});
